import { SignalingMessageConnectReply } from "../../../services";
import { BaseStreamingCommand } from "./BaseStreamingCommand";
import { UniqueEntityId } from "@kernel/ddd";

export class ConnectionCommand extends BaseStreamingCommand {
  public execute(e: unknown): void {
    const event = e as CustomEvent<SignalingMessageConnectReply>;
    const message = event.detail;
    const room = this.getRoom();
    const localParticipant = room.localParticipant!;
    localParticipant.remoteId = new UniqueEntityId(message.data.id);
    this.bloc.changeState({
      ...this.bloc.state,
      room
    });
    this.signalingService.setUsername(
      room.id,
      localParticipant.displayName,
      localParticipant.type
    );
  }
}
